import React, { useState, useEffect, useRef } from "react";
import { uploadEmployeeDocument } from "../../api/employeeApi";
import { useNavigate } from "react-router-dom";

const UploadDocument = () => {
  
  const navigate = useNavigate();

  const [employeeCode, setEmployeeCode] = useState("");
  const [financialYear, setFinancialYear] = useState("");
  const [sectionCode, setSectionCode] = useState("");
  const [purpose, setPurpose] = useState("");
  const [amount, setAmount] = useState("");
  const [file, setFile] = useState(null);
  const fileInputRef = useRef(null);
  const [errors, setErrors] = useState({});
  const [message, setMessage] = useState("");
  const [isSuccess, setIsSuccess] = useState(false);

  useEffect(() => {
    const code = sessionStorage.getItem("username");
    if (code) setEmployeeCode(code);
  }, []);

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  // ✅ Validation
  const validateForm = () => {
    let formErrors = {};

    if (!employeeCode) formErrors.employeeCode = "Employee Code is required";
    if (!financialYear) {
      formErrors.financialYear = "Financial Year is required";
    } else if (!/^\d{8}$/.test(financialYear)) {
      formErrors.financialYear =
        "Financial Year must be exactly 8 digits (e.g. 20242025)";
    }
    if (!sectionCode) formErrors.sectionCode = "Section is required";
    if (!purpose.trim()) formErrors.purpose = "Purpose is required";
    if (!amount) formErrors.amount = "Amount is required";
    if (!file) formErrors.file = "File is required";

    setErrors(formErrors);
    return Object.keys(formErrors).length === 0;
  };

  const handleUpload = async (e) => {
  e.preventDefault();

  if (!validateForm()) return;

  const formData = new FormData();
  formData.append("EmployeeCode", employeeCode);
  formData.append("FinancialYear", financialYear);
  formData.append("SectionCode", sectionCode);
  formData.append("Purpose", purpose);
  formData.append("Amount", amount);
  formData.append("File", file);
  formData.append("CrUser", sessionStorage.getItem("username"));
  formData.append("CrDate", new Date().toISOString());
  formData.append("Deleted", "N");

  try {
    const result = await uploadEmployeeDocument(formData);

    if (result.success) {
      setIsSuccess(true);
      setMessage(result.message || "File uploaded successfully!");

      // Show alert for success
      alert("✅ Document saved successfully!");

      // Reset form except employee code
      setFinancialYear("");
      setSectionCode("");
      setPurpose("");
      setAmount("");
      setFile(null);
      setErrors({});
      if (fileInputRef.current) fileInputRef.current.value = "";
    } else {
      setIsSuccess(false);
      setMessage(result.message || "Error uploading file.");

      // Show alert for failure
      alert("❌ Failed to upload document. Please try again. Check Uploading File.");
    }
  } catch (error) {
    setIsSuccess(false);
    setMessage("Unexpected error occurred.");

    // Show alert for exception
    alert("⚠️ Unexpected error occurred while uploading.");
  }
};

  return (
    <div
      className="upload-container"
      style={{ maxWidth: "500px", margin: "auto" }}
    >
      {/* <h5>Upload Document</h5> */}
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h4 className="allowance-heading mb-0">Upload Document</h4>
        
        <button className="btn btn-primary btn-sm" onClick={() => navigate("uploaded-document")}>
            View Uploaded Documents
        </button>
      </div>

      <form onSubmit={handleUpload}>
        {/* Employee Code */}
        <div style={{ marginBottom: "10px" }}>
          <label>Employee Code:</label>
          <input
            type="text"
            value={employeeCode}
            readOnly
            style={{
              width: "100%",
              padding: "5px",
              backgroundColor: "#f0f0f0",
            }}
          />
          {errors.employeeCode && (
            <p style={{ color: "red" }}>{errors.employeeCode}</p>
          )}
        </div>

        {/* Financial Year */}
        <div style={{ marginBottom: "10px" }}>
          <label>Financial Year:</label>
          <input
            type="text"
            value={financialYear}
            onChange={(e) => {
              const value = e.target.value;
              if (/^\d*$/.test(value)) setFinancialYear(value); // only digits
            }}
            maxLength={8}
            placeholder="e.g. 20242025"
            style={{ width: "100%", padding: "5px" }}
          />
          {errors.financialYear && (
            <p style={{ color: "red" }}>{errors.financialYear}</p>
          )}
        </div>

        {/* Section */}
        <div style={{ marginBottom: "10px" }}>
          <label>Section:</label>
          <select
            value={sectionCode}
            onChange={(e) => setSectionCode(e.target.value)}
            style={{ width: "100%", padding: "5px" }}
          >
            <option value="">Select Section</option>
            <option value="80C">80C</option>
            <option value="80D">80D</option>
            <option value="80E">80E</option>
            <option value="80G">80G</option>
            <option value="80T">80T</option>
            <option value="80U">80U</option>
            <option value="ETC">ETC</option>
          </select>
          {errors.sectionCode && (
            <p style={{ color: "red" }}>{errors.sectionCode}</p>
          )}
        </div>

        {/* Purpose */}
        <div style={{ marginBottom: "10px" }}>
          <label>Purpose:</label>
          <input
            type="text"
            value={purpose}
            onChange={(e) => setPurpose(e.target.value)}
            placeholder="e.g. PPF, LIC, Mutual Fund"
            style={{ width: "100%", padding: "5px" }}
          />
          {errors.purpose && (
            <p style={{ color: "red" }}>{errors.purpose}</p>
          )}
        </div>

        {/* Amount */}
        <div style={{ marginBottom: "10px" }}>
          <label>Amount:</label>
          <input
            type="number"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
            style={{ width: "100%", padding: "5px" }}
          />
          {errors.amount && <p style={{ color: "red" }}>{errors.amount}</p>}
        </div>

        {/* File */}
        <div style={{ marginBottom: "10px" }}>
          <label>Upload Document:</label>
          <input
            type="file"
            accept=".pdf,.jpeg,.jpg,.png"
            onChange={handleFileChange}
            ref={fileInputRef}
          />
          {errors.file && <p style={{ color: "red" }}>{errors.file}</p>}
        </div>

        <button type="submit" style={{ padding: "5px 10px" }}>
          Upload
        </button>
      </form>
    </div>
  );
};

export default UploadDocument;




// import React, { useState, useEffect, useRef } from "react";
// import { uploadEmployeeDocument } from "../../api/employeeApi";


// const UploadDocument = () => {
//   const [employeeCode, setEmployeeCode] = useState("");
//   const [financialYear, setFinancialYear] = useState("");
//   const [sectionCode, setSectionCode] = useState("");
//   const [purpose, setPurpose] = useState("");
//   const [amount, setAmount] = useState("");
//   const [file, setFile] = useState(null);
//   const fileInputRef = useRef(null); // Ref for file input
//   const [message, setMessage] = useState("");

//   useEffect(() => {
//     const code = sessionStorage.getItem("username"); // Fetch EmployeeCode
//     if (code) setEmployeeCode(code);
//   }, []);

//   const handleFileChange = (e) => {
//     setFile(e.target.files[0]);
//   };

// const handleUpload = async (e) => {
//    e.preventDefault();
 
//    if (!employeeCode || !financialYear || !sectionCode || !purpose || !amount || !file) {
//      alert("Please fill all fields and select a file.");
//      return;
//    }
 
//    const formData = new FormData();
//    formData.append("EmployeeCode", employeeCode);
//    formData.append("FinancialYear", financialYear);
//    formData.append("SectionCode", sectionCode);
//    formData.append("Purpose", purpose);
//    formData.append("Amount", amount);
//    formData.append("File", file);
//    formData.append("CrUser", sessionStorage.getItem("username"));
//    formData.append("CrDate", new Date().toISOString());
//    formData.append("Deleted", "N");
 
//    const result = await uploadEmployeeDocument(formData);
 
//    if (result.success) {
//      alert(result.message);
 
//      // Clear form except EmployeeCode
//      setFinancialYear("");
//      setSectionCode("");
//      setPurpose("");
//      setAmount("");
//      setFile(null);
//      if (fileInputRef.current) fileInputRef.current.value = "";
//    } else {
//      alert(result.message);
//    }
//  };
 
//   return (
//     <div className="upload-container" style={{ maxWidth: "500px", margin: "auto" }}>
//       <h4>Upload Document</h4>
//       <form onSubmit={handleUpload}>
//         <div style={{ marginBottom: "10px" }}>
//           <label>Employee Code:</label>
//           <input
//             type="text"
//             value={employeeCode}
//             readOnly
//             style={{ width: "100%", padding: "5px", backgroundColor: "#f0f0f0" }}
//           />
//         </div>

//         {/* <div style={{ marginBottom: "10px" }}>
//           <label>Financial Year:</label>
//           <input
//             type="text"
//             value={financialYear}
//             onChange={(e) => setFinancialYear(e.target.value)}
//             placeholder="e.g. 20242025"
//             style={{ width: "100%", padding: "5px" }}
//           />
//         </div> */}

//         <div style={{ marginBottom: "10px" }}>
//           <label>Financial Year:</label>
//           <input
//             type="text"
//             value={financialYear}
//             onChange={(e) => {
//               const value = e.target.value;
            
//               // Allow only digits
//               if (/^\d*$/.test(value)) {
//                 setFinancialYear(value);
//               }
//             }}
//             onBlur={() => {
//               if (financialYear && !/^\d{8}$/.test(financialYear)) {
//                 alert("Financial Year must be exactly 8 digits (e.g. 20242025)");
//                 setFinancialYear("");
//               }
//             }}
//             maxLength={8}
//             placeholder="e.g. 20242025"
//             style={{ width: "100%", padding: "5px" }}
//           />
//         </div>


//         <div style={{ marginBottom: "10px" }}>
//           <label>Section:</label>
//           <select
//             value={sectionCode}
//             onChange={(e) => setSectionCode(e.target.value)}
//             style={{ width: "100%", padding: "5px" }}
//           >
//             <option value="">Select Section</option>
//             <option value="80C">80C</option>
//             <option value="80D">80D</option>
//             <option value="80E">80E</option>
//             <option value="80G">80G</option>
//             <option value="80U">80T</option>
//             <option value="80U">80U</option>
//             <option value="ETC">ETC</option>
//           </select>
//         </div>

//         <div style={{ marginBottom: "10px" }}>
//           <label>Purpose:</label>
//           <input
//             type="text"
//             value={purpose}
//             onChange={(e) => setPurpose(e.target.value)}
//             placeholder="e.g. PPF, LIC, Mutual Fund"
//             style={{ width: "100%", padding: "5px" }}
//           />
//         </div>

//         <div style={{ marginBottom: "10px" }}>
//           <label>Amount:</label>
//           <input
//             type="number"
//             value={amount}
//             onChange={(e) => setAmount(e.target.value)}
//             style={{ width: "100%", padding: "5px" }}
//           />
//         </div>

//         <div style={{ marginBottom: "10px" }}>
//           <label>Upload Document:</label>
//           <input
//             type="file"
//             accept=".pdf,.jpeg,.jpg,.png"
//             onChange={handleFileChange}
//             ref={fileInputRef} // Attach ref here
//           />
//         </div>

//         <button type="submit" style={{ padding: "5px 10px" }}>
//           Upload
//         </button>
//       </form>
//     </div>
//   );
// };

// export default UploadDocument;
